import lodash from 'lodash';

export function wordify(text: string) {
  let words = text.split(/([A-Z][a-z]+)/g);
  return words.map((v) => lodash.capitalize(v)).join(' ');
}
